/* eslint-disable  */

import React, { Suspense, useEffect, Profiler, useRef } from "react";
import { APIClient, unsetAuthToken } from "./api/_api";
import { account } from "@api/Api";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import Avatar from "@components/avatar";
import { handleLogout } from "@store/authentication";
import { removeMenu, getAllMenu, getCurrentRoute } from "@store/layout";
// ** Router Import
import Router from "./router/Router";
import { useNavigate, useLocation } from "react-router-dom";
import { Coffee, X } from "react-feather";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import FacebookMessenger from "./../src/views/apps/facebookMessanger";

import moment from "moment-timezone";

library.add(fas, far);

const ToastContent = ({ text }) => {
  return (
    <div className="d-flex">
      <div className="me-1">
        <Avatar size="sm" color={`danger`} icon={<Coffee size={12} />} />
      </div>
      <div className="d-flex flex-column">
        <span>{text}</span>
      </div>
    </div>
  );
};

const MyProfiler = ({
  id,
  phase,
  actualDuration,
  baseDuration,
  startTime,
  commitTime,
  interactions,
}) => {
  // console.log(`Component "${id}" was rendered in phase "${phase}"`);
  // console.log(`Actual duration: ${actualDuration}`);
  // Add your custom profiling data handling logic here
};

const App = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const prevLocation = useRef(location);

  const interceptorsHandler = () => {
    APIClient.interceptors.response.use(
      (response) => {
        if (response.data && response.data.message) {
        }
        return response;
      },
      (error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          dispatch(handleLogout());
          dispatch(removeMenu());
          localStorage.removeItem("menu");
          navigate("/login");
        }
        console.log(error);

        if (
          location.pathname.includes("/apps/order/paymentDebit") ||
          location.pathname.includes("/apps/order/paymentECheck")
        ) {
          return Promise.reject(error);
        }
        toast((t) => (
          <ToastContent t={t} text={error?.response?.data?.message} />
        ));

        // Always reject the promise
        return Promise.reject(error);
      }
    );

    APIClient.interceptors.request.use((config) => {
      const token =
        localStorage.getItem("accessToken") &&
        localStorage.getItem("accessToken");
      const withoutFirstAndLast = token?.slice(1, -1);
      config.headers.authorization = `Bearer ${withoutFirstAndLast}`;
      return config;
    });
  };

  const getMenu = async (response) => {
    try {
      const modifiedData = await response.map((item) => ({
        ...item,
        // icon: React.createElement(iconComponents[item.iconName], {
        //   size: 20,
        // }),

        icon: <FontAwesomeIcon icon={`fa-solid ${item.iconName}`} />,
        id: item.key,
      }));

      for (const item of modifiedData) {
        if (item.children.length === 0) {
          delete item.children;
        }
        delete item.iconName;
        delete item.iconSize;
        delete item.sort;
      }
      return modifiedData;
    } catch (error) {
      console.error(error);
    }
  };

  const getMe = async () => {
    try {
      const { data, status } = await account.getMe();
      if (status !== 200) {
        return;
      }

      // setUserData(data.data);
      const newData = {
        ...data.data,
        accessToken: data.data.Token,
        refreshToken: data.data.Token,
        ability: [{ action: "manage", subject: "all" }],
      };
      localStorage.setItem("userData", JSON.stringify(newData));
      const currentPath = location.pathname;
      if (
        data?.data?.contractStatus === 1 ||
        data?.data?.contractStatus === 4
      ) {
        if (currentPath !== "/apps/ContractSeeLib") {
          if (data.data?.roleID?.key === "saleAgent") {
            navigate(`/apps/ContractSeeLib`);
          }
        }
      }
      if (
        data?.data?.roleID?.key !==
        JSON.parse(localStorage.getItem("userData")).roleID.key
      ) {
        dispatch(handleLogout());
        dispatch(removeMenu());
        localStorage.removeItem("menu");

        navigate("/login");
        // for change route with out force log out the user
        // dispatch(removeMenu());
        // localStorage.removeItem("menu");
        // setTimeout(() => {
        //   dispatch(getAllMenu()).then(async (response) => {
        //     const menuLocal = await getMenu(response?.payload?.data?.data);
        //     localStorage.setItem(
        //       "menu",
        //       JSON.stringify(response?.payload?.data?.data)
        //     );
        //   });
        // }, 2000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    interceptorsHandler();
    moment.tz.setDefault("America/New_York");
  }, []);

  // useEffect(() => {
  //   moment.tz.setDefault("America/New_York");
  //   // localStorage.removeItem("menu");
  //   const handleNavigate = (newLocation, action) => {
  //     dispatch(getCurrentRoute(newLocation.pathname));

  //     console.log(`The route changed to ${newLocation.pathname} via ${action}`);
  //     const token =
  //       localStorage.getItem("accessToken") &&
  //       localStorage.getItem("accessToken");
  //     if (!token) {
  //       return;
  //     }
  //     getMe();
  //   };

  //   // Check if the location has changed
  //   if (location !== prevLocation.current) {
  //     handleNavigate(location, "POP"); // 'POP' indicates a manual change
  //   }

  //   // Save the current location for the next comparison
  //   prevLocation.current = location;

  //   // Subscribe to popstate events to detect browser back/forward button clicks
  //   const popstateListener = () => {
  //     handleNavigate(location, "POPSTATE");
  //   };

  //   window.addEventListener("popstate", popstateListener);

  //   // Cleanup: Remove the popstate event listener when the component is unmounted
  //   return () => {
  //     window.removeEventListener("popstate", popstateListener);
  //   };
  // }, [location, navigate]);

  return (
    <Profiler id="app" onRender={MyProfiler}>
      <Suspense fallback={null}>
        {/* <FacebookMessenger pageId="101242635080277" /> */}
        <Router />
      </Suspense>
    </Profiler>
  );
};

export default App;
